<template>
  <div>
    <!-- A -->
    <div class="abcSelect" >
      <div class="abcSelect__item abcSelect__item_recommend">
        <div class="abcSelect__item_recommend-icon">We recommend it!</div>
        <div class="abcSelect__title">Comprehensive QIC Complete</div>
        <div class="abcSelect__desc">Covers damages to your car due to accidents, including off-road accidents, natural disasters, fire, and theft</div>
        <ul class="abcSelect__list">
          <li class="abcSelect__list-item">
            <svg><use xlink:href="../assets/images/abcSelect.svg#tpl"></use></svg>
            Third Party Liability
          </li>
          <li class="abcSelect__list-item">
            <svg><use xlink:href="../assets/images/abcSelect.svg#passenger"></use></svg>
            Passenger Liability
          </li>
          <li class="abcSelect__list-item">
            <svg><use xlink:href="../assets/images/abcSelect.svg#OwnDamage"></use></svg>
            Own Damage
          </li>
          <li class="abcSelect__list-item">
            <svg><use xlink:href="../assets/images/abcSelect.svg#elite"></use></svg>
            24/7 Elite Roadside Assistance
          </li>
          <li class="abcSelect__list-item abcSelect__list-item_allot">
            <svg><use xlink:href="../assets/images/abcSelect.svg#more"></use></svg>
            10 More Covers You Need
          </li>
        </ul>
        <div class="abcSelect__total">
          <div class="abcSelect__info">
            <a href="#" @click.prevent="openPopup('complete')" class="abcSelect__learnmore">Learn more</a>
            <div class="abcSelect__price">From QAR 4,900
              <span class="abcSelect__installment">or monthly QAR 300 </span>
            </div>
          </div>
          <BaseButton @click="$emit('selected', 'complete')" class="btn_medium" symbol="no">
            <template v-slot:default>
              {{ $t('qic_select') }}
            </template>
          </BaseButton>
        </div>
      </div>

      <div class="abcSelect__item">
        <div class="abcSelect__title">Standard Comprehensive</div>
        <div class="abcSelect__desc">Insurance policy includes TPL and safeguards your car against unforeseen own damages</div>
        <ul class="abcSelect__list">
          <li class="abcSelect__list-item">
            <svg><use xlink:href="../assets/images/abcSelect.svg#tpl"></use></svg>
            Third Party Liability
          </li>
          <li class="abcSelect__list-item">
            <svg><use xlink:href="../assets/images/abcSelect.svg#passenger"></use></svg>
            Passenger Liability
          </li>
          <li class="abcSelect__list-item">
            <svg><use xlink:href="../assets/images/abcSelect.svg#OwnDamage"></use></svg>
            Own Damage
          </li>
        </ul>
        <div class="abcSelect__total">
          <div class="abcSelect__info">
            <a href="#" @click.prevent="openPopup('comprehensive')" class="abcSelect__learnmore">Learn more</a>
            <div class="abcSelect__price">From QAR 1,400</div>
          </div>
          <BaseButton @click="$emit('selected', 'comprehensive')" class="btn_medium" symbol="no">
            <template v-slot:default>
              {{ $t('qic_select') }}
            </template>
          </BaseButton>
        </div>
      </div>

      <div v-if="plan !== 'comprehensive-plan-a'" class="abcSelect__item">
        <div class="abcSelect__title">Third Party Liability</div>
        <div class="abcSelect__desc">Covers injuries you may cause to other people as well as damage to their property</div>
        <div class="abcSelect__total">
          <div class="abcSelect__info">
            <a href="#" @click.prevent="openPopup('tpl')" class="abcSelect__learnmore">Learn more</a>
            <div class="abcSelect__price">From QAR 400</div>
          </div>
          <BaseButton @click="$emit('selected', 'tpl')" class="btn_medium" symbol="no">
            <template v-slot:default>
              {{ $t('qic_select') }}
            </template>
          </BaseButton>
        </div>
      </div>
    </div>
    <!--  -->
    <div class="abcSelect abcSelect_switch" v-if="plan === 'plan-b' || plan === 'plan-c' || plan === 'tpl-plan-a' || plan === 'tpl-plan-b'">
      <div class="abcSelect_switch__item">
        <div class="abcSelect_switch__desc">Compulsory Insurance</div>

        <div class="abcSelect__item abcSelect_switch__disabled">
          <div class="abcSelect__title">Third Party Liability (TPL)
            <label class="form-switch">
              <input type="checkbox" checked disabled>
              <i></i>
            </label>
          </div>
          <div class="abcSelect__desc">Covers injuries you may cause to other people as well as damage to their property</div>
          <div class="abcSelect__total">
            <div class="abcSelect__info">
              <a href="#" class="abcSelect__learnmore" @click.prevent="openPopup('tpl')">Learn more</a>
              <div class="abcSelect__price">From QAR 400</div>
            </div>
          </div>
        </div>
      </div>
      <div class="abcSelect_switch__item">
        <div class="abcSelect_switch__desc">Choose to Activate <span>Comprehensive</span></div>

        <div class="abcSelect__item">
          <div class="abcSelect__title"><span>Own Damage <span class="recommend">We Recommend</span></span>
            <label class="form-switch">
              <input v-model="ownDamage" type="checkbox">
              <i></i>
            </label>
          </div>
          <div class="abcSelect__desc">Covers damages to your car and any injuries you may suffer</div>
          <div class="abcSelect__total">
            <div class="abcSelect__info">
              <a href="#" class="abcSelect__learnmore" @click.prevent="openPopup('comprehensive')">Learn more</a>
              <div class="abcSelect__price">From QAR 1,400</div>
            </div>
          </div>
        </div>
      </div>
      <div class="abcSelect_switch__item" v-show="!showDescription">
        <div class="abcSelect_switch__desc">Additional Covers Avaliable Only With <span>Comprehensive</span></div>

        <div class="abcSelect__item">
          <ul class="abcSelect__list">
            <li class="abcSelect__list-item abcSelect__list-item_disabled">
              <svg><use xlink:href="../assets/images/abcSelect.svg#disabled"></use></svg>
              No Spare Parts Deprecation
            </li>
            <li class="abcSelect__list-item abcSelect__list-item_disabled">
              <svg><use xlink:href="../assets/images/abcSelect.svg#disabled"></use></svg>
              Unknown damage
            </li>
            <li class="abcSelect__list-item abcSelect__list-item_disabled">
              <svg><use xlink:href="../assets/images/abcSelect.svg#disabled"></use></svg>
              Agency Repairs
            </li>
          </ul>
        </div>
      </div>
      <div class="abcSelect_switch__item" v-show="showDescription">
        <div class="abcSelect_switch__desc">Adjust Covers Next</div>

        <div class="abcSelect__item">
          <ul class="abcSelect__list">
            <li class="abcSelect__list-item">
              <svg><use xlink:href="../assets/images/abcSelect.svg#parts"></use></svg>
              No Spare Parts Deprecation
            </li>
            <li class="abcSelect__list-item">
              <svg><use xlink:href="../assets/images/abcSelect.svg#damage"></use></svg>
              Unknown damage
            </li>
            <li class="abcSelect__list-item">
              <svg><use xlink:href="../assets/images/abcSelect.svg#fix"></use></svg>
              Agency Repairs
            </li>
          </ul>
        </div>
      </div>
      <BaseButton @click="$emit('selected', next)" class="btn w-100" />
    </div>
  </div>
</template>

<script>

export default {
  name: 'SelectPlan',
  components: {
  },
  props: {
    plan: {
      type: String,
      required: false
    }
  },
  data () {
    return {
      showPopup: false,
      popupComponent: null,
      next: '',
      showDescription: false
    }
  },
  computed: {
    ownDamage: {
      get () {
        if (this.plan === 'plan-c' || this.plan === 'tpl-plan-b') {
          return true
        }
        return false
      },
      set (value) {
        if (value) {
          this.next = 'comprehensive'
        } else {
          this.next = 'tpl'
        }
        this.showDescription = value
        return value
      }
    }
  },
  mounted () {
    if (this.plan === 'plan-c' || this.plan === 'tpl-plan-b') {
      this.next = 'comprehensive'
      this.showDescription = true
    } else {
      this.next = 'tpl'
    }
  },
  methods: {
    openPopup (popup) {
      this.$emit('open-popup', popup)
    }
  }
}
</script>

<style scoped>
  .w-100 {
    width: 100%;
  }
</style>
